export default class DropdownMenuToggle {
  constructor(element) {
    let toggleBtn = element.getElementsByClassName(
      "dropdown-navigation__button",
    )[0];
    if (!toggleBtn) {
      return;
    }
    this.element = element;
    this.toggleBtn = toggleBtn;
    let toggle = function (e) {
      e.stopPropagation();
      let target = this;
      if (target.getAttribute("aria-expanded") === "true") {
        this.setAttribute("aria-expanded", false);
      } else {
        this.setAttribute("aria-expanded", true);
      }

      let mobileNav = document.querySelector(".header__mobile-menu");
      if (mobileNav) {
        let mobileMenuToggle = mobileNav.querySelector(".js-menu-toggle");
        if (mobileMenuToggle) {
          if (mobileMenuToggle.classList.contains("is-expanded")) {
            mobileMenuToggle.classList.remove("is-expanded");
          }
        }
      }
    };
    toggleBtn.addEventListener("click", toggle);
    document.addEventListener("click", (e) => {
      if (this.toggleBtn.getAttribute("aria-expanded") === "true") {
        this.toggleBtn.setAttribute("aria-expanded", false);
      }
    });
  }
}
